import type en from '../en/sites'
import type { Translation } from '../types'

/** Sites */
const sites: Translation<typeof en> = {
  "sites.deleted": "Site supprimé",
  "sites.deleteFailed": "Impossible de supprimer le site",
  "sites.syncTriggered": "Synchronisation lancée",
  "sites.syncFailed": "Échec de la synchronisation",
  "sites.managed": { one: "{count} site géré", other: "{count} sites gérés" },
  "sites.addSite": "Ajouter un site",
  "sites.site": "Site",
  "sites.location": "Emplacement",
  "sites.lastSync": "Dernière synchronisation",
  "sites.none": "Aucun site pour l’instant — ajoutez votre premier site UniFi",
  "sites.notInLicence": "Hors de votre licence",
  "sites.configureDevice": "Configurer l’appareil",
  "sites.syncNow": "Synchroniser maintenant",
  "sites.confirmDelete": "Supprimer le site « {name} » ?",
  "sites.add.title": "Ajouter un site UniFi",
  "sites.add.name": "Nom du site *",
  "sites.add.namePlaceholder": "Siège social",
  "sites.add.locationPlaceholder": "Paris, France",
  "sites.add.descriptionPlaceholder": "Description facultative",
  "sites.add.apiKey": "Clé API UniFi *",
  "sites.add.apiKeyPlaceholder": "Clé API de l’application UniFi Network",
  "sites.add.signInWith": "Se connecter avec",
  "sites.add.signInKey": "Clé API (console UniFi OS)",
  "sites.add.signInLogin": "Nom d’utilisateur et mot de passe (Network Server auto-hébergé)",
  "sites.add.username": "Nom d’utilisateur *",
  "sites.add.password": "Mot de passe *",
  "sites.add.loginHint": "Un Network Server auto-hébergé n’a pas de clés API : utilisez-y un compte local sans vérification en deux étapes. Le mot de passe est chiffré et jamais affiché.",
  "sites.add.controllerUrl": "URL du contrôleur",
  "sites.add.hintConsole": "Console UniFi OS (Dream Machine, Cloud Gateway, Cloud Key) :",
  "sites.add.hintSelfHosted": "Network Server auto-hébergé :",
  "sites.add.hintSiteManager": "Pour les consoles accessibles via unifi.ui.com, utilisez « + Site Manager ».",
  "sites.add.siteId": "ID du site",
  "sites.add.note": "Remarque :",
  "sites.add.noteText": "Après l’ajout, un compte VPN est créé automatiquement. Le site devient actif dès qu’il se connecte via le VPN.",
  "sites.synced": "Synchronisé",
  "sites.notFound": "Site introuvable",
  "sites.back": "Retour aux sites",
  "sites.firmwareAvailable": "⬆ Micrologiciel disponible",
  "sites.lastSyncWhen": "Dernière synchronisation {when}",
  "sites.never": "jamais",
  "sites.sync": "Synchroniser",
  "sites.tab.overview": "Vue d’ensemble",
  "sites.tab.topology": "Topologie",
  "sites.tab.devices": "Appareils ({count})",
  "sites.tab.vlans": "VLAN ({count})",
  "sites.tab.wifi": "Wi-Fi ({count})",
  "sites.tab.clients": "Clients ({count})",
  "sites.tab.traffic": "Trafic",
  "sites.tab.alerts": "Alertes",
  "sites.tab.alertsCount": "Alertes ({count})",
  "sites.connectedNow": "connectés maintenant",
  "sites.connectionsUp": "connexions actives",
  "sites.download": "Réception",
  "sites.upload": "Envoi",
  "sites.uploadRate": "{rate} en envoi",
  "sites.experienceScore": "Score d’expérience",
  "sites.wifiGood": "✓ Bonne expérience Wi-Fi",
  "sites.wifiFair": "⚠ Expérience Wi-Fi correcte",
  "sites.wifiPoor": "✕ Mauvaise expérience Wi-Fi",
  "sites.averageAcross": { one: "Moyenne sur {count} client sans fil", other: "Moyenne sur {count} clients sans fil" },
  "sites.wanConnections": "Connexions WAN",
  "sites.loadBalanced": "Répartition de charge",
  "sites.noWan": "Pas encore de données WAN",
  "sites.throughput": "Débit",
  "sites.noHistory": "Pas encore d’historique",
  "sites.noTopology": "Aucune donnée de topologie — synchronisez d’abord le site",
  "sites.networkTopology": "Topologie du réseau",
  "sites.connectionsCount": { one: "{count} connexion", other: "{count} connexions" },
  "sites.legend.wired": "— Liaison filaire",
  "sites.legend.wireless": "– – Liaison sans fil (maillée)",
  "sites.legend.ap": "📶 Point d’accès",
  "sites.legend.switch": "🔀 Commutateur",
  "sites.legend.gateway": "🔒 Passerelle",
  "sites.legend.clientCount": "🔵 = nombre de clients",
  "sites.legend.update": "⬆ = mise à jour disponible",
  "sites.model": "Modèle",
  "sites.type": "Type",
  "sites.experience": "Expérience",
  "sites.firmwareUpdate": "⬆ Mise à jour du micrologiciel disponible",
  "sites.radios": "Radios",
  "sites.channel": "Canal {channel}",
  "sites.utilization": "Utilisation : {percent} %",
  "sites.noDevices": "Aucun appareil",
  "sites.update": "⬆ Mise à jour",
  "sites.uptime": "DISPONIBILITÉ",
  "sites.clientsCaps": "CLIENTS",
  "sites.radioTable": "Table des radios",
  "sites.channelUtilization": "Utilisation du canal",
  "sites.portTable": "Table des ports",
  "sites.port": "Port",
  "sites.portN": "Port {n}",
  "sites.speed": "Vitesse",
  "sites.down": "Inactif",
  "sites.upBadge": "ACTIF",
  "sites.downBadge": "INACTIF",
  "sites.uptimeDays": "{d} j {h} h",
  "sites.uptimeHours": "{h} h {m} min",
  "sites.vlanId": "ID de VLAN",
  "sites.purpose": "Usage",
  "sites.subnet": "Sous-réseau",
  "sites.noVlans": "Aucun VLAN",
  "sites.noWifi": "Aucun réseau Wi-Fi",
  "sites.guest": "INVITÉ",
  "sites.clientsLower": "clients",
  "sites.busiest": "Le plus chargé : {ap} ({count})",
  "sites.client": "Client",
  "sites.connection": "Connexion",
  "sites.noClients": "Aucun client",
  "sites.conn.wired": "filaire",
  "sites.conn.wireless": "sans fil",
  "sites.dpi.0": "Autre",
  "sites.dpi.1": "Messagerie instantanée",
  "sites.dpi.2": "P2P",
  "sites.dpi.3": "Transfert de fichiers",
  "sites.dpi.4": "Streaming",
  "sites.dpi.5": "E-mail",
  "sites.dpi.6": "VoIP",
  "sites.dpi.7": "Jeux",
  "sites.dpi.8": "Réseaux sociaux",
  "sites.dpi.9": "Publicité",
  "sites.dpi.10": "Web",
  "sites.dpi.11": "Sécurité",
  "sites.dpi.other": "Cat. {n}",
  "sites.noDpi": "Aucune donnée DPI — nécessite UniFi avec la DPI activée",
  "sites.trafficByCategory": "Trafic par catégorie",
  "sites.breakdown": "Répartition",
  "sites.noActiveAlerts": "Aucune alerte active",
  "sites.config.field.enableDisable": "Liaison activée",
  "sites.config.help.enableDisable": "Activer ou désactiver la liaison montante",
  "sites.config.field.priority": "Priorité",
  "sites.config.help.priority": "Le plus petit nombre l’emporte lorsque plusieurs liaisons sont actives",
  "sites.config.field.failover": "Basculement",
  "sites.config.help.failover": "Basculer vers une liaison de secours si celle-ci tombe en panne",
  "sites.config.field.loadBalance": "Répartition de charge",
  "sites.config.help.loadBalance": "Répartir les sessions entre les liaisons actives",
  "sites.config.field.weights": "Poids de répartition",
  "sites.config.help.weights": "Part du trafic pour cette liaison",
  "sites.config.field.healthCheck": "Contrôle d’état",
  "sites.config.help.healthCheck": "Tester la liaison et la marquer inactive en cas d’échec",
  "sites.config.field.smartQueue": "Smart Queue (QoS)",
  "sites.config.help.smartQueue": "Réduire le bufferbloat en charge",
  "sites.config.field.staticIp": "IP statique",
  "sites.config.help.staticIp": "Laisser vide pour le DHCP",
  "sites.config.field.mtu": "MTU",
  "sites.config.help.mtu": "Généralement 1500, ou 1492 pour le PPPoE",
  "sites.config.field.simSwitch": "Emplacement SIM actif",
  "sites.config.help.simSwitch": "Le changement coupe brièvement la connexion",
  "sites.config.field.apn": "APN",
  "sites.config.help.apn": "Nom du point d’accès de l’opérateur",
  "sites.config.field.dataLimit": "Limite de données mensuelle",
  "sites.config.help.dataLimit": "Les alertes se déclenchent à 90 % de cette valeur",
  "sites.config.field.roaming": "Autoriser l’itinérance",
  "sites.config.help.roaming": "Coûteux hors du réseau d’origine",
  "sites.config.field.bandLock": "Verrouillage de bande",
  "sites.config.help.bandLock": "Bandes séparées par des virgules, vide = automatique",
  "sites.config.field.pin": "Code PIN de la SIM",
  "sites.config.field.ssid": "SSID",
  "sites.config.field.security": "Sécurité",
  "sites.config.field.band": "Bande",
  "sites.config.field.guest": "Réseau invité",
  "sites.config.help.guest": "Isole les clients du LAN",
  "sites.config.field.vlanTag": "Étiquette VLAN",
  "sites.config.field.schedule": "Planification activée",
  "sites.config.field.txPower": "Puissance d’émission",
  "sites.config.field.fastRoaming": "Itinérance rapide (802.11r)",
  "sites.config.field.mode": "Rôle",
  "sites.config.field.frequency": "Fréquence",
  "sites.config.help.frequency": "Radios 60 GHz : 58320, 60480, 62640, 64800 ou 66000",
  "sites.config.field.channelWidth": "Largeur de canal",
  "sites.config.help.channelWidth": "Non utilisé en 60 GHz",
  "sites.config.field.protocol": "Protocole",
  "sites.config.help.protocol": "Pilote « wireless » 2,4/5 GHz uniquement",
  "sites.config.field.linkKey": "Clé de liaison",
  "sites.config.help.linkKey": "Au moins 8 caractères ; doit être identique aux deux extrémités. Jamais affichée une fois enregistrée",
  "sites.config.field.linkTxPower": "Puissance d’émission",
  "sites.config.help.linkTxPower": "Restez dans la limite de votre domaine réglementaire",
  "sites.config.field.linkSsid": "Nom de la liaison (SSID)",
  "sites.config.help.linkSsid": "Doit être identique aux deux extrémités",
  "sites.config.field.vlan": "VLAN",
  "sites.config.field.dhcp": "Serveur DHCP",
  "sites.config.field.firewall": "Pare-feu",
  "sites.config.field.portForward": "Redirection de ports",
  "sites.config.field.staticRoutes": "Routes statiques",
  "sites.config.field.dns": "Serveurs DNS",
  "sites.config.help.dns": "Séparés par des virgules",
  "sites.config.field.speedfusion": "SpeedFusion",
  "sites.config.field.reconnect": "Reconnecter le tunnel",
  "sites.config.help.reconnect": "Coupe et rétablit l’agrégation",
  "sites.config.field.createProfile": "Nouveau profil",
  "sites.config.field.vpnClient": "Client VPN",
  "sites.config.field.reboot": "Redémarrer l’appareil",
  "sites.config.help.reboot": "L’appareil est hors ligne pendant 1 à 2 minutes",
  "sites.config.field.firmwareCheck": "Rechercher un micrologiciel",
  "sites.config.field.firmwareUpgrade": "Installer le micrologiciel",
  "sites.config.help.firmwareUpgrade": "Applique la dernière version disponible",
  "sites.config.field.backup": "Sauvegarder la configuration",
  "sites.config.field.restore": "Restaurer la configuration",
  "sites.config.field.ntp": "Serveur NTP",
  "sites.config.field.timezone": "Fuseau horaire",
  "sites.config.field.hostname": "Nom d’hôte",
  "sites.config.field.adminPassword": "Mot de passe administrateur",
  "sites.config.section.wan": "WAN",
  "sites.config.blurb.wan": "Comportement de la liaison montante, basculement et répartition de charge",
  "sites.config.section.cellular": "Cellulaire",
  "sites.config.blurb.cellular": "SIM, APN, limites de données et itinérance",
  "sites.config.section.wifi": "Wi-Fi",
  "sites.config.blurb.wifi": "SSID, sécurité et paramètres radio",
  "sites.config.section.link": "Liaison radio",
  "sites.config.blurb.link": "Paramètres des liaisons point à point et point à multipoint. Modifiez d’abord chaque station, puis le point d’accès dans les 10 minutes ; la fréquence se règle uniquement sur le point d’accès.",
  "sites.config.section.network": "Réseau",
  "sites.config.blurb.network": "VLAN, DHCP, pare-feu et routage",
  "sites.config.section.tunnel": "Tunnels",
  "sites.config.blurb.tunnel": "Profils SpeedFusion et client VPN",
  "sites.config.section.system": "Système",
  "sites.config.blurb.system": "Redémarrage, micrologiciel, heure et identité",
  "sites.config.option.ap-ptp": "Point d’accès — point à point",
  "sites.config.option.ap-ptmp": "Point d’accès — point à multipoint",
  "sites.config.option.station": "Station (extrémité distante / CPE)",
  "sites.config.option.open": "ouvert",
  "sites.config.option.both": "les deux",
  "sites.config.option.auto": "auto",
  "sites.config.option.low": "faible",
  "sites.config.option.medium": "moyenne",
  "sites.config.option.high": "élevée",
  "sites.config.option.any": "tous",
  "sites.config.applied": { one: "{count} modification appliquée", other: "{count} modifications appliquées" },
  "sites.config.someFailed": "Certaines modifications ont échoué",
  "sites.config.unsupportedHere": "Non pris en charge sur cet appareil",
  "sites.config.title": "Configurer {name}",
  "sites.config.subtitle": "Seules les options prises en charge par cet appareil sont affichées",
  "sites.config.hide": "Masquer",
  "sites.config.history": "Historique",
  "sites.config.apply": "Appliquer {count}",
  "sites.config.missing": "Configuration manquante : {items} — reconnectez ce site pour activer la configuration.",
  "sites.config.readOnly": "{label} est en lecture seule dans ce tableau de bord. La surveillance fonctionne normalement.",
  "sites.config.readFailed": "Les paramètres actuels n’ont pas pu être lus sur l’appareil",
  "sites.config.readFailedNote": "Les champs ci-dessous sont vides parce qu’ils sont inconnus, et non parce qu’ils sont désactivés.",
  "sites.config.available": "Disponible sur cet appareil",
  "sites.config.appliesTo": "S’applique à",
  "sites.config.notSupportedBy": "Non pris en charge par {label}",
  "sites.config.raw": "État brut de l’appareil",
  "sites.config.changed": "modifié",
  "sites.config.notReported": "État actuel non communiqué par l’appareil",
  "sites.config.unknownState": "État actuel inconnu",
  "sites.config.discard": "Annuler cette modification",
  "sites.config.historyTitle": "Historique des modifications de configuration",
  "sites.config.noChanges": "Aucune modification enregistrée pour l’instant",
  "sites.config.when": "Quand",
  "sites.config.section": "Section",
  "sites.config.field": "Champ",
  "sites.config.value": "Valeur",
  "sites.search": "Rechercher des sites",
  "sites.searchPlaceholder": "Rechercher par nom…",
  "sites.brand": "Marque",
  "sites.allBrands": "Toutes les marques",
  "sites.noneMatch": "Aucun site ne correspond",
  "sites.matching": { one: "{count} site correspond", other: "{count} sites correspondent" },
  "sites.config.offline.copy": "Cette unité est hors ligne — réglages tels que lus {when}. Les modifications sont gardées et envoyées à son retour.",
  "sites.config.offline.none": "Cette unité n’a pas encore été jointe — les modifications sont gardées et envoyées au premier contact.",
  "sites.config.offline.save": "Garder pour plus tard ({count})",
  "sites.config.offline.saved": { one: "{count} modification gardée pour le retour de l’unité", other: "{count} modifications gardées pour le retour de l’unité" },
  "sites.config.offline.pendingValue": "en attente : {value} · {by} · {when}",
  "sites.pending.title": "Modifications en attente",
  "sites.pending.waitingUnit": "Envoyée au retour de l’unité",
  "sites.pending.conflict": "Modifié sur l’unité en {unit} — la vôtre : {mine}",
  "sites.pending.keepMine": "Garder la mienne",
  "sites.pending.keepUnit": "Garder celle de l’unité",
  "sites.pending.waitingFor": "Attend que {names} reçoive d’abord sa propre modification de lien",
  "sites.pending.release": "Envoyer quand même",
  "sites.pending.failed": "Échec : {error}",
  "sites.pending.discard": "Abandonner",
  "sites.pending.decision": "Décision requise",
  "sites.pending.count": { one: "{count} en attente", other: "{count} en attente" },
  "sites.config.offline.noneSeen": "Cette unité ne répond pas pour l’instant et ses réglages n’ont pas encore été lus — les modifications sont gardées et envoyées au prochain contact.",
  "sites.cloud.status.OK": "Fonctionne",
  "sites.cloud.status.WAITING_VPN": "Attend son VPN",
  "sites.cloud.status.FAILED": "Échec",
  "sites.cloud.reach.PUBLIC": "À une adresse",
  "sites.cloud.reach.VIA_SITE_VPN": "Par le VPN d’un site",
  "sites.cloud.reach.OWN_VPN": "La propre connexion VPN du contrôleur",
  "sites.cloud.reachHint.PUBLIC": "Le contrôleur répond à une adresse publique avec un certificat valide.",
  "sites.cloud.reachHint.VIA_SITE_VPN": "Un appareil sur l’un de vos sites avec une connexion VPN redirige le port du contrôleur — sans abonnement cloud ni port ouvert.",
  "sites.cloud.reachHint.OWN_VPN": "L’ordinateur du contrôleur se connecte lui-même au VPN de la plateforme (OpenVPN sous Windows ou Linux).",
  "sites.cloud.reachHint.needsVpn": "Nécessite l’autorisation de gérer les connexions VPN.",
  "sites.cloud.connectionName": "Nom",
  "sites.cloud.connectionNamePlaceholder": "p. ex. Contrôleur du siège",
  "sites.cloud.reachLabel": "Comment le tableau de bord joint le contrôleur",
  "sites.cloud.address": "Adresse du contrôleur",
  "sites.cloud.addressHint": "Un certificat valide est nécessaire : à une adresse publique, rien d’autre ne prouve qui répond.",
  "sites.cloud.noVpnSites": "Aucun de vos sites n’a encore de connexion VPN. Ajoutez-en d’abord un (un MikroTik, une passerelle UniFi ou tout client VPN sur place).",
  "sites.cloud.viaSite": "Site",
  "sites.cloud.chooseSite": "Choisissez un site",
  "sites.cloud.port": "Port du contrôleur",
  "sites.cloud.forwardIntro": "Sur l’appareil de {site}, redirigez le port {port} de son adresse VPN {ip} vers l’adresse LAN du contrôleur.",
  "sites.cloud.lanAddress": "Adresse LAN du contrôleur",
  "sites.cloud.forwardMikrotik": "Sur un MikroTik, dans son terminal :",
  "sites.cloud.lanPlaceholder": "<adresse LAN du contrôleur>",
  "sites.cloud.credentials": "Identifiants Omada",
  "sites.cloud.credentialsWhere": "Dans le contrôleur Omada, ouvrez {menu}, ajoutez une application en mode Client et copiez son Client ID et son Client secret. L’Omada ID figure sur la même page.",
  "sites.cloud.omadacId": "Omada ID",
  "sites.cloud.clientId": "Client ID",
  "sites.cloud.clientSecret": "Client secret",
  "sites.cloud.keptPlaceholder": "Défini — laissez vide pour le garder",
  "sites.cloud.registerTitle": "Ajouter des sites Omada",
  "sites.cloud.registerSubtitle": "Les sites d’un contrôleur TP-Link Omada, joint par votre VPN ou à une adresse",
  "sites.cloud.savedWaiting": "Enregistré — en attente de la connexion VPN du contrôleur",
  "sites.cloud.connected": "Connecté au contrôleur",
  "sites.cloud.connectFailed": "Connexion impossible",
  "sites.cloud.otherConnection": "Autre connexion",
  "sites.cloud.failed": "Dernière erreur : {reason}",
  "sites.cloud.editInSettings": "Modifier la connexion",
  "sites.cloud.useConnection": "Utiliser une connexion",
  "sites.cloud.newConnection": "Une nouvelle connexion",
  "sites.cloud.connect": "Connecter",
  "sites.cloud.downloadFailed": "Échec du téléchargement",
  "sites.cloud.waitingTitle": "En attente de la connexion VPN du contrôleur",
  "sites.cloud.waitingText": "Téléchargez cette connexion VPN et lancez-la sur l’ordinateur du contrôleur. Dès que son tunnel est établi, les identifiants sont vérifiés et les sites du contrôleur apparaissent ici — cette page vérifie toutes les 10 secondes.",
  "sites.cloud.downloadOvpn": "Télécharger le .ovpn",
  "sites.cloud.ovpnWindows": "Windows : installez OpenVPN, importez le fichier et connectez-vous ; réglez le service OpenVPN en démarrage automatique pour que le tunnel revienne après un redémarrage.",
  "sites.cloud.ovpnLinux": "Linux : copiez le fichier dans /etc/openvpn/client/velanox.conf et lancez systemctl enable --now openvpn-client@velanox.",
  "sites.cloud.added": { one: "{count} site ajouté", other: "{count} sites ajoutés" },
  "sites.cloud.addFailed": "Impossible d’ajouter les sites",
  "sites.cloud.sitesFailed": "Les sites du contrôleur n’ont pas pu être lus : {reason}",
  "sites.cloud.controllerSites": "Sites du contrôleur",
  "sites.cloud.noControllerSites": "Le contrôleur n’a aucun site.",
  "sites.cloud.deviceCount": { one: "{count} appareil", other: "{count} appareils" },
  "sites.cloud.alreadyAdded": "Ajouté",
  "sites.cloud.addSites": { one: "Ajouter {count} site", other: "Ajouter {count} sites" },
  "sites.cloud.through": "Par {name} · {reach}",
  "sites.cloud.synced": "synchronisé {when}",
  "sites.cloud.configure": "Configurer",
  "sites.cloud.devicesOnline": "Appareils en ligne",
  "sites.cloud.clients": "Clients",
  "sites.cloud.uplinksUp": "Liaisons montantes actives",
  "sites.cloud.openAlerts": "Alertes ouvertes",
  "sites.cloud.devices": "Appareils",
  "sites.cloud.noDevices": "Aucun appareil sur ce site pour l’instant.",
  "sites.cloud.type": "Type",
  "sites.cloud.uptime": "Disponibilité",
  "sites.cloud.deviceType.ap": "Point d’accès",
  "sites.cloud.deviceType.switch": "Switch",
  "sites.cloud.deviceType.gateway": "Passerelle",
  "sites.cloud.deviceType.other": "Autre",
  "sites.cloud.updateAvailable": "Mise à jour disponible",
  "sites.cloud.restart": "Redémarrer",
  "sites.cloud.restartSent": "Redémarrage envoyé",
  "sites.cloud.restartConfirm": "Redémarrer {name} ? Ses clients perdent leur connexion pendant environ deux minutes.",
  "sites.cloud.upgrade": "Mettre à jour le firmware",
  "sites.cloud.upgradeSent": "Mise à jour du firmware lancée",
  "sites.cloud.upgradeConfirm": "Mettre à jour le firmware de {name} ? Il redémarre et ses clients perdent leur connexion pendant environ deux minutes.",
  "sites.cloud.noClients": "Aucun client connecté.",
  "sites.cloud.connection": "Connexion",
  "sites.cloud.blocked": "Bloqué",
  "sites.cloud.wireless": "Sans fil",
  "sites.cloud.wired": "Filaire",
  "sites.cloud.unblock": "Débloquer",
  "sites.cloud.unblocked": "Débloqué",
  "sites.cloud.block": "Bloquer",
  "sites.cloud.blockedDone": "Bloqué",
  "sites.cloud.blockConfirm": "Bloquer {name} ? Il ne pourra plus se connecter avant d’être débloqué.",
  "sites.cloud.reconnect": "Reconnecter",
  "sites.cloud.reconnectSent": "Reconnexion envoyée",
  "sites.cloud.uplinks": "Liaisons montantes",
  "sites.cloud.noUplinks": "Aucune liaison montante signalée.",
  "sites.cloud.up": "Active",
  "sites.cloud.down": "Coupée",
  "sites.cloud.alerts": "Alertes",
  "sites.cloud.events": "Événements récents de {vendor}",
  "sites.cloud.eventsFailed": "Le contrôleur n’a pas répondu : {reason}",
  "sites.cloud.noEvents": "Aucun événement récent.",
  "sites.config.field.ssidOn": "SSID activé",
  "sites.config.field.wifiKey": "Clé WiFi",
  "sites.config.help.wifiKey": "Écrite uniquement : la clé actuelle n’est jamais affichée",
  "sites.config.field.networkName": "Nom du réseau",
  "sites.config.field.siteName": "Nom du site sur le contrôleur",
  "sites.config.help.siteName": "Le nom du site dans le tableau de bord reste tel quel",
  "sites.config.secretSet": "Définie — saisissez-en une nouvelle pour la changer",
  "sites.cloud.lanAddressHint": "Sa propre adresse sur le réseau du site : la redirection va vers elle, et le réseau où il se trouve garde son VLAN depuis ici.",
  "sites.cloud.controllerPort": "Port propre du contrôleur",
  "sites.cloud.controllerPortHint": "8043 sur un contrôleur logiciel, 443 sur un OC200 ou OC300",
  "sites.cloud.secretAgain": "Saisissez à nouveau le client secret si l’adresse, le site ou le port change : il n’est jamais envoyé de lui-même à une nouvelle adresse.",
  "sites.config.historySection.devices": "Appareils",
  "sites.config.historySection.clients": "Clients",
  "sites.removeSite": "Supprimer le site",
  "sites.removeConfirm": "Supprimer le site « {name} » ? Son historique, ses alertes, ses réglages et sa connexion VPN disparaissent avec lui. C’est irréversible.",
  "sites.config.help.radioOn": "Éteindre une radio qui porte une liaison coupe cette liaison",
  "sites.vpn.title": "Connexion VPN",
  "sites.vpn.connected": "Connecté",
  "sites.vpn.waiting": "En attente de sa connexion VPN",
  "sites.vpn.notConnected": "Non connecté",
  "sites.vpn.waitingPage": "En attente de sa connexion VPN : les détails de l’appareil s’affichent ici dès qu’il se connecte",
  "sites.vpn.tunnelAddress": "Adresse du tunnel",
  "sites.vpn.lastSeen": "Dernière connexion",
  "sites.vpn.never": "Jamais",
  "sites.vpn.loadHint": "Chargez ce fichier sur le routeur comme client OpenVPN et autorisez HTTPS (port 443) depuis le VPN sur le routeur (sur un Teltonika : Réseau → Pare-feu → Traffic rules, de la zone openvpn vers l’appareil, TCP 443, accepter) ; le site passe en ligne ici dès qu’il se connecte",
  "sites.vpn.download": "Télécharger le .ovpn",
  "sites.vpn.downloadFailed": "Échec du téléchargement",
  "sites.vpn.renew": "Renouveler le certificat",
  "sites.vpn.renewed": "Nouveau fichier VPN créé pour le site",
  "sites.vpn.renewFailed": "Aucun nouveau fichier VPN n’a pu être créé",
  "sites.signIn.change": "Modifier la connexion",
  "sites.signIn.title": "Modifier la connexion de {name}",
  "sites.signIn.hint": "Un champ laissé vide garde ce qui est enregistré. Les mots de passe et jetons sont chiffrés et jamais affichés.",
  "sites.signIn.user": "Nom d’utilisateur",
  "sites.signIn.password": "Mot de passe",
  "sites.signIn.token": "Jeton d’API",
  "sites.signIn.apiKey": "Clé API",
  "sites.signIn.save": "Enregistrer la connexion",
  "sites.signIn.saved": "Connexion enregistrée",
  "sites.signIn.savedText": "L’appareil est interrogé à nouveau avec elle",
  "sites.signIn.failed": "La connexion n’a pas pu être enregistrée",
  "sites.direct.toggle": "Désactiver la connexion VPN et utiliser une adresse directe ou une IP",
  "sites.add.vpnLine": "Joint par sa connexion VPN, à l’adresse de tunnel de la passerelle — trouvée d’elle-même",
  "sites.event.brand": "Événements",
  "sites.event.badge": "Événement",
  "sites.event.archived": "Archivé",
  "sites.archivedHint": "Sites des événements clôturés : gardés ici pendant la durée d’archivage des réglages de location, puis supprimés.",
  "sites.event.rentalEvent": "Événement de location",
  "sites.event.period": "Période de location",
  "sites.event.material": "Matériel sorti et rentré",
  "sites.event.devices": "Appareils",
  "sites.event.device": "Appareil",
  "sites.event.cameIn": "Arrivé dans",
  "sites.event.state": "Statut",
  "sites.event.uptime": "Disponibilité",
  "sites.event.clients": "Clients",
  "sites.event.traffic": "Trafic",
  "sites.event.lastSeen": "Vu pour la dernière fois",
  "sites.event.noDevices": "Aucun appareil chargé n’est sorti pour l’instant",
  "sites.event.hidden": { one: "{count} appareil masqué : vous ne pouvez pas voir son site", other: "{count} appareils masqués : vous ne pouvez pas voir leurs sites" },
  "sites.event.alerts": "Alertes",
  "sites.event.noAlerts": "Aucune alerte",
  "sites.event.resolved": "résolue",
  "sites.event.clientList": "Clients du réseau",
  "sites.event.noClients": "Aucun client",
  "sites.event.loads": "Ce qui est sorti",
  "sites.event.noLoads": "Rien n’est encore sorti",
  "sites.event.wentOut": "Sorti {when} · {who}",
  "sites.event.cameBack": "Rentré {when} · {who} : {status}",
  "sites.event.stillOut": "encore sorti",
  "sites.event.cameBackOf": "{back} sur {out} revenus",
  "sites.event.graphs": "Graphiques",
  "sites.event.range": "Période",
  "sites.event.range24h": "24 h",
  "sites.event.range3d": "3 jours",
  "sites.event.range1w": "1 semaine",
  "sites.event.rangeThisMonth": "Ce mois-ci",
  "sites.event.rangeLastMonth": "Le mois dernier",
  "sites.event.rangeCustom": "Personnalisée",
  "sites.event.from": "Du",
  "sites.event.to": "Au",
  "sites.event.rangeInvalid": "La fin est avant le début",
  "sites.event.totalInRange": "Sur cette période : ↓ {rx} · ↑ {tx}",
  "sites.event.graphTraffic": "Trafic total",
  "sites.event.graphDevices": "Appareils en ligne et hors ligne",
  "sites.event.noSamples": "Rien d’enregistré sur cette période : les graphiques se remplissent tant que le matériel est sorti",
  "sites.event.asTable": "Afficher sous forme de tableau",
  "sites.event.time": "Heure",
  "sites.cloud.username": "Nom d’utilisateur",
  "sites.cloud.password": "Mot de passe",
  "sites.cloud.registerTitleSz": "Ajouter des sites Ruckus",
  "sites.cloud.registerSubtitleSz": "Les zones d’un contrôleur Ruckus SmartZone, joint par le VPN d’un site ou à une adresse",
  "sites.cloud.credentialsSz": "Identifiants SmartZone",
  "sites.cloud.credentialsWhereSz": "Un administrateur SmartZone avec un rôle en lecture-écriture ({menu})",
  "sites.cloud.secretAgainSz": "Saisissez à nouveau le mot de passe lorsque l’adresse, le site ou le port change : il n’est jamais envoyé de lui-même à une nouvelle adresse.",
  "sites.cloud.controllerPortHintSz": "8443 sur SmartZone",
  "sites.cloud.siteFirmware": "Mettre à jour le firmware AP",
  "sites.cloud.siteFirmwareCurrent": "Version actuelle",
  "sites.cloud.siteFirmwareNew": "Nouvelle version",
  "sites.cloud.siteFirmwareNone": "Aucune version plus récente sur le contrôleur",
  "sites.cloud.siteFirmwareUpdate": "Mettre à jour",
  "sites.cloud.siteFirmwareConfirm": "Chaque point d’accès de ce site redémarre pour passer à {version}. Continuer ?",
  "sites.cloud.siteFirmwareSent": "Mise à jour du firmware lancée",
  "sites.config.wifiOnly": "Les sites de ce contrôleur n’ont que des réglages WiFi : les VLAN se règlent par réseau WiFi.",
  "sites.event.comment": "Commentaire",
  "sites.event.commentOf": "Commentaire pour {name}",
  "sites.event.commentPlaceholder": "Ajouter un commentaire",
  "sites.event.commentSaved": "Commentaire enregistré",
  "sites.event.commentFailed": "Le commentaire n’a pas été enregistré",
  "sites.event.commentBy": "{name}, {when}",
  "sites.add.choose": "Qu'ajoutez-vous ?",
  "sites.speedTest": "Test de débit ↓ {down} ↑ {up}",
  "sites.speedTestAt": "Le dernier test de débit de la passerelle, {when} : ce que la ligne peut porter",
  "sites.dataUsed": "Données utilisées ({period}) : ↓ {rx} ↑ {tx}",
}

export default sites
